/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Common_Hours_AgoInputs */

const en_common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}h ago`)
};

const de_common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vor ${i?.count} Std.`)
};

const fr_common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il y a ${i?.count} h`)
};

const es_common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hace ${i?.count} h`)
};

const it_common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}h fa`)
};

const nl_common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}u geleden`)
};

const pl_common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}h temu`)
};

const fi_common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}h sitten`)
};

const da_common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}t siden`)
};

const sv_common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}h sedan`)
};

/**
* | output |
* | --- |
* | "{count}h ago" |
*
* @param {Common_Hours_AgoInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_hours_ago = /** @type {((inputs: Common_Hours_AgoInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Hours_AgoInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_hours_ago(inputs)
	if (locale === "fr") return fr_common_hours_ago(inputs)
	if (locale === "es") return es_common_hours_ago(inputs)
	if (locale === "it") return it_common_hours_ago(inputs)
	if (locale === "nl") return nl_common_hours_ago(inputs)
	if (locale === "pl") return pl_common_hours_ago(inputs)
	if (locale === "fi") return fi_common_hours_ago(inputs)
	if (locale === "da") return da_common_hours_ago(inputs)
	if (locale === "sv") return sv_common_hours_ago(inputs)
	return en_common_hours_ago(inputs)
});